import {Component} from '@angular/core';

@Component({
  selector:'present-by-columns',
  template:``,
  styles:[``]
})

export class PresentByColumnComponent {

}
